module.exports = __webpack_public_path__ + "static/media/speakerFive.f0229d2f.jpg";